<template>
  <div class="whole">
    <div flexContainer v-if="isTable == true">
      <div class="circle"></div>
      <div class="text">
        <span class="pop" v-if="pageTitle == '首页'" @click="go_back_f">{{
          pageTitle
        }}</span>
        <span
          class="pop"
          v-else-if="pageTitle == '应用管理'"
          @click="go_back_app"
          >{{ pageTitle }}</span
        >
        <span class="pop" v-else>{{ pageTitle }}</span>
        <span class="pop" v-show="texts_status != -1">{{ finger_right }}</span>
        <span v-if="texts_status == 1">更新版本</span>
        <span v-if="texts_status == 2">创建应用</span>
        <span v-if="texts_status == 3">版本信息</span>
      </div>
      <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item
          class="text"
          v-if="pageTitle == '首页'"
          @click="go_back_f"
          :to="{ path: '/tools_f',query:{texts_status:-1} }"
          >{{ pageTitle }}</el-breadcrumb-item
        >
        <el-breadcrumb-item
          class="text"
          v-else-if="pageTitle == '应用管理'"
          :to="{ path: '/tools_app',query:{texts_status:-1} }"
          >{{ pageTitle }}</el-breadcrumb-item
        >
        <el-breadcrumb-item class="text" v-else>{{
          pageTitle
        }}</el-breadcrumb-item>
        <template v-show="texts_status != -1">
          <el-breadcrumb-item
            class="text"
            v-if="texts_status == 1"
            :to="{ path: '/tools_app' }"
            >更新版本</el-breadcrumb-item
          >
          <el-breadcrumb-item
            v-if="texts_status == 2"
            class="text"
            :to="{ path: '/tools_app' }"
            >创建应用</el-breadcrumb-item
          >
          <el-breadcrumb-item
            v-if="texts_status == 3"
            class="text"
            :to="{ path: '/tools_f' }"
            >版本信息</el-breadcrumb-item
          >
        </template>
      </el-breadcrumb> -->
    </div>
    <div class="back" v-else @click="go_back">
      <span>{{ finger }}</span
      >返回
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      finger: "<",
      finger_right: ">",
    };
  },
  methods: {
    go_back_f() {
      this.$store.state.texts_status = -1
      this.$router.push({ path: "/tools_f" });
    },
    go_back_app() {
      this.$store.state.texts_status = -1
      this.$router.push({ path: "/tools_app" });
    },
    go_back() {
      this.$router.back();
      this.$store.state.isTable = true;
    },
  },
  computed: mapState(["isTable", "pageTitle", "isUpdate", "texts_status"]),
  watch:{
    isTable(val){
      console.log(val)

    }
  }
};
</script>
<style lang="scss" scoped>
.whole {
  .circle {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: black;
    margin-top: 8px;
    margin-right: 6px;
  }
  .back {
    width: 100px;
    @include s-c-w(14, $menu-text, 500);
    cursor: pointer;
    span {
      margin-right: 5px;
    }
  }
  .text {
    @include s-c-w(16, $menu-text, bold);
    .pop {
      @include s-c-w(16, $menu-text, bold);
      margin-right: 5px;
      cursor: pointer;
    }
    span {
      @include s-c-w(16, $tab, bold);
    }
  }
}
</style>
